import { Component, inject, OnInit, Signal } from '@angular/core';
import { ContentComponent } from '../../../components/content/content.component';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { CaseEntityAppEntityCaseEntityRead, ShipmentAppEntityShipmentRead } from '../../../openapi';
import { LabelComponent } from '../../../common/label/label.component';
import { DatePipe } from '@angular/common';
import { SpinnerComponent } from '../../../common/spinner/spinner.component';
import { Store } from '@ngrx/store';
import {
  selectCaseItem,
  selectCaseShipments,
  selectLoading,
  selectPending
} from '../../../store/selectors/my-cases.selectors';
import { AlertComponent } from '../../../common/alert/alert.component';
import { loadCaseItem } from '../../../store/actions/my-cases.actions';
import { FormsModule } from '@angular/forms';
import { MyCasesFilterPipe, ShipmentFilterValue } from '../../../pipes/my-cases-filter.pipe';
import { selectServices } from '../../../store/selectors/app.selectors';
import { map } from 'rxjs/operators';
import { ServiceListItem } from '../../../services/service.common.model';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-my-case-details-page',
  standalone: true,
  imports: [
    ContentComponent,
    BreadcrumbsComponent,
    RouterLink,
    LabelComponent,
    DatePipe,
    SpinnerComponent,
    AlertComponent,
    FormsModule,
    MyCasesFilterPipe
  ],
  templateUrl: './my-case-details-page.component.html'
})
export class MyCaseDetailsPageComponent implements OnInit {

  public shipmentType: ShipmentFilterValue = 'all';

  private route: ActivatedRoute = inject(ActivatedRoute);

  private store$: Store = inject(Store);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public shipments: Signal<Array<ShipmentAppEntityShipmentRead>> = this.store$.selectSignal(selectCaseShipments);

  public case: Signal<CaseEntityAppEntityCaseEntityRead | null> = this.store$.selectSignal(selectCaseItem);

  public services: Signal<ServiceListItem[] | undefined> = toSignal(
    this.store$.select(selectServices).pipe(
      map(v => v.filter(s => !!s?.isCaseRelated))
    )
  );

  public ngOnInit(): void {
    this.store$.dispatch(loadCaseItem({ id: this.route.snapshot.params['caseId'] }));
  }

}
